import React, { useCallback } from 'react';
import { Platform, TouchableOpacity, View } from 'react-native';
import { useNavigation, StackActions } from '@react-navigation/native';
import Text from '../Text';

import ArrowLeftSVG from '../../assets/svgs/arrow-left.svg';
import CloseSVG from '../../assets/svgs/close.svg';
import LogoSVG from '../../assets/svgs/logo.svg';
import FloatingMenu from './components/FloatingMenu';
import colors from '~/assets/themes/colors';
import useHeader from '~/hooks/useHeader';
import useAppNavigation from '~/hooks/useAppNavigation';
import useToast from '~/hooks/useToast';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';

interface TitleProps {
  title: string;
}

export const Title = ({ title }: TitleProps) => {
  return <Text className="text-center">{title}</Text>;
};

export const Background = () => {
  return (
    <View className="flex-1 bg-light-100 flex items-center justify-center" />
  );
};

export const CloseButton = () => {
  const { dispatch } = useNavigation();
  return (
    <TouchableOpacity
      className="mr-4"
      onPress={() => dispatch(StackActions.replace('Home'))}
    >
      <CloseSVG height={24} width={24} color={colors.gray[400]} />
    </TouchableOpacity>
  );
};

interface ArrowLeftProps {
  onPress?: () => void;
}

export const ArrowLeft = ({ onPress }: ArrowLeftProps) => {
  const { canBack, onGoBack } = useHeader();

  if (!canBack) {
    return null;
  }

  return (
    <TouchableOpacity className="ml-4" onPress={() => onGoBack(onPress)}>
      <ArrowLeftSVG color={colors.gray[400]} />
    </TouchableOpacity>
  );
};

interface LogoProps {
  canGoBack?: boolean;
}

export const Logo = ({ canGoBack = true }: LogoProps) => {
  const { navigate } = useAppNavigation();
  const { showModalAlert } = useToast();

  const handleNavigate = useCallback(() => {
    if (Platform.OS === 'web') {
      navigate('MarisaServicos_Home');
      return;
    }

    showModalAlert({
      title: 'Tem certeza que deseja voltar?',
      onPress: () => navigate('MarisaServicos_Home'),
    });
  }, [navigate, showModalAlert]);

  return (
    <TouchableOpacity
      disabled={!canGoBack}
      activeOpacity={1}
      onPress={handleNavigate}
    >
      <LogoSVG />
    </TouchableOpacity>
  );
};

export const AuthButton = () => {
  const { isLoggedIn, onPressLogin } = useHeader();

  return (
    <View className="pr-4">
      {MarisaAppUtils.disableInsurance ? (
        <></>
      ) : (
        <>
          {isLoggedIn ? (
            <FloatingMenu />
          ) : (
            <TouchableOpacity
              onPress={onPressLogin}
              className="bg-primary-600 py-1 px-2 rounded-2xl"
            >
              <Text className="text-light-100 font-bold text-xs">Entrar</Text>
            </TouchableOpacity>
          )}
        </>
      )}
    </View>
  );
};
